(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 7805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(7937);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ globals; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/colors.tsx
var colors = __webpack_require__(4568);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/font-style.tsx
var font_style = __webpack_require__(597);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/layout.tsx
var layout = __webpack_require__(5452);
;// CONCATENATED MODULE: ./src/assets/styles/utilities/normalize.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n  *,\n  ::before,\n  ::after {\n    box-sizing: border-box; /* 1 */\n    border-width: 0; /* 2 */\n    border-style: solid; /* 2 */\n    border-color: theme("borderColor.DEFAULT", currentColor); /* 2 */\n  }\n  *:focus {\n    outline: none;\n  }\n\n  ::before,\n  ::after {\n    --tw-content: "";\n  }\n\n  html {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    -moz-tab-size: 4; /* 3 */\n    tab-size: 4; /* 3 */\n    font-family: theme(\n      "fontFamily.sans",\n      ui-sans-serif,\n      system-ui,\n      -apple-system,\n      BlinkMacSystemFont,\n      "Segoe UI",\n      Roboto,\n      "Helvetica Neue",\n      Arial,\n      "Noto Sans",\n      sans-serif,\n      "Apple Color Emoji",\n      "Segoe UI Emoji",\n      "Segoe UI Symbol",\n      "Noto Color Emoji"\n    ); /* 4 */\n  }\n\n  body {\n    margin: 0; /* 1 */\n    line-height: inherit; /* 2 */\n  }\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    text-decoration: underline dotted;\n  }\n\n  /*\nRemove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\nAdd the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: theme(\n      "fontFamily.mono",\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      "Liberation Mono",\n      "Courier New",\n      monospace\n    ); /* 1 */\n    font-size: 1em; /* 2 */\n  }\n\n  small {\n    font-size: 80%;\n  }\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit; /* 1 */\n    font-size: 100%; /* 1 */\n    font-weight: inherit; /* 1 */\n    line-height: inherit; /* 1 */\n    color: inherit; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 3 */\n  }\n\n  button,\n  select {\n    text-transform: none;\n  }\n\n  button,\n  button:focus,\n  button:active {\n    outline: none;\n  }\n\n  button,\n  [type="button"],\n  [type="reset"],\n  [type="submit"] {\n    -webkit-appearance: button; /* 1 */\n    background-color: transparent; /* 2 */\n    background-image: none; /* 2 */\n  }\n\n  /*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n  [type="search"] {\n    -webkit-appearance: textfield; /* 1 */\n    outline-offset: -2px; /* 2 */\n  }\n\n  /*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button; /* 1 */\n    font: inherit; /* 2 */\n  }\n\n  /*\nAdd the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\nRemoves the default spacing and border for appropriate elements.\n*/\n\n  blockquote,\n  dl,\n  dd,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  hr,\n  figure,\n  p,\n  pre {\n    margin: 0;\n  }\n\n  fieldset {\n    margin: 0;\n    padding: 0;\n  }\n\n  legend {\n    padding: 0;\n  }\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  /*\nPrevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user\'s configured gray 400 color.\n*/\n\n  input::placeholder,\n  textarea::placeholder {\n    opacity: 1; /* 1 */\n    color: theme("colors.gray.400", #9ca3af); /* 2 */\n  }\n\n  /*\nSet the default cursor for buttons.\n*/\n\n  button,\n  [role="button"] {\n    cursor: pointer;\n  }\n\n  /*\nMake sure disabled buttons don\'t get the pointer cursor.\n*/\n  :disabled {\n    cursor: default;\n  }\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n  }\n\n  /*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 30px white inset !important;\n  }\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const normalize = (0,emotion_react_browser_esm/* css */.iv)(_templateObject());
/* harmony default export */ var utilities_normalize = (normalize);

;// CONCATENATED MODULE: ./src/assets/styles/globals.tsx

function globals_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        "\n        body {\n          font-family: ",
        ";\n          color: ",
        ";\n          &.stop-scroll {\n            overflow: hidden;\n          }\n          .Toastify__toast {\n            background: none !important;\n            box-shadow: none !important;\n            padding: 0;\n          }\n          .Toastify__toast-container {\n            padding: 0;\n            left: auto;\n            right: 0;\n            ",
        " {\n              width: fit-content;\n              bottom: 60px;\n            }\n          }\n        }\n      "
    ]);
    globals_templateObject = function() {
        return data;
    };
    return data;
}






const Globals = ()=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
        styles: (0,emotion_react_browser_esm/* css */.iv)(globals_templateObject(), utilities_normalize, font_style/* default.family.montserrat */.Z.family.montserrat, colors/* default.black */.Z.black, layout/* default.mediaBreakpointDown */.Z.mediaBreakpointDown("md"))
    });
};
/* harmony default export */ var globals = (Globals);


/***/ }),

/***/ 9991:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const border = {
    width: {
        1: "0.5px",
        2: "1px",
        3: "1.5px",
        4: "2px",
        5: "2.5px",
        6: "3px"
    },
    radius: {
        1: "0.125em",
        2: "0.25em",
        3: "0.375em",
        4: "0.5em",
        5: "0.75em",
        6: "0.875em",
        7: "1em",
        8: "1.125em",
        9: "1.375em",
        10: "1.5em"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (border);


/***/ }),

/***/ 5334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cg": function() { return /* reexport */ border/* default */.Z; },
  "Wn": function() { return /* reexport */ box_shadows; },
  "O9": function() { return /* reexport */ colors/* default */.Z; },
  "JB": function() { return /* reexport */ font_size/* default */.Z; },
  "p_": function() { return /* reexport */ font_style/* default */.Z; },
  "bK": function() { return /* reexport */ layout/* default */.Z; },
  "e6": function() { return /* reexport */ margins/* default */.Z; },
  "o3": function() { return /* reexport */ paddings/* default */.Z; }
});

// UNUSED EXPORTS: text

// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/border.tsx
var border = __webpack_require__(9991);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/colors.tsx
var colors = __webpack_require__(4568);
;// CONCATENATED MODULE: ./src/assets/styles/utilities/variables/box-shadows.tsx

const boxShadow = {
    1: "0px 3px 6px ".concat(colors/* default.gray.400 */.Z.gray[400]),
    2: "8px 8px 9px #a7a7a780"
};
/* harmony default export */ var box_shadows = (boxShadow);

// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/font-size.tsx
var font_size = __webpack_require__(2493);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/font-style.tsx
var font_style = __webpack_require__(597);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/layout.tsx
var layout = __webpack_require__(5452);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/margins.tsx
var margins = __webpack_require__(8176);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/paddings.tsx
var paddings = __webpack_require__(8999);
;// CONCATENATED MODULE: ./src/assets/styles/utilities/variables/text.tsx
const text_text = {
    lineHeight: {
        1: "0.125em",
        2: "0.25em",
        3: "0.375em",
        4: "0.5em",
        5: "0.75em",
        6: "0.875em",
        7: "1em",
        8: "1.125em",
        9: "1.375em",
        10: "1.5em"
    },
    letterSpacing: {
        1: "0.125em",
        2: "0.25em",
        3: "0.375em",
        4: "0.5em",
        5: "0.75em",
        6: "0.875em",
        7: "1em",
        8: "1.125em",
        9: "1.375em",
        10: "1.5em"
    }
};
/* harmony default export */ var variables_text = ((/* unused pure expression or super */ null && (text_text)));

;// CONCATENATED MODULE: ./src/assets/styles/utilities/variables/index.tsx












/***/ }),

/***/ 8176:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const margin = {
    1: "0.125em",
    2: "0.25em",
    3: "0.375em",
    4: "0.5em",
    5: "0.75em",
    6: "0.875em",
    7: "1em",
    8: "1.125em",
    9: "1.375em",
    10: "1.5em"
};
/* harmony default export */ __webpack_exports__["Z"] = (margin);


/***/ }),

/***/ 844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(1998);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/index.tsx + 2 modules
var variables = __webpack_require__(5334);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(6565);
;// CONCATENATED MODULE: ./src/components/Button/Button.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .icon {\n      color: ",
        ";\n    }\n    font-family: ",
        ";\n    height: fit-content;\n    gap: 0.63rem;\n    background: ",
        ";\n    color: ",
        ";\n    border: ",
        " solid ",
        ";\n    display: flex;\n    justify-content: ",
        ";\n    align-items: center;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    text-transform: capitalize;\n    padding: ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n    border-color: ",
        ";\n    position: relative;\n\n    &:focus {\n      box-shadow: 0 0 0 0.2rem ",
        ";\n    }\n\n    &:hover {\n      opacity: 0.9;\n    }\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* position: absolute; */\n    border-radius: 100%;\n    width: 1.5em;\n    height: 1.5em;\n    right: 50%;\n    top: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-left-color: #fff;\n    border-top-color: #fff;\n    display: ",
        ";\n    animation: ",
        ";\n\n    @keyframes spin {\n      to {\n        transform: rotate(359deg);\n      }\n    }\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





const buttonThemes = {
    warn: {
        color: variables/* colors.white */.O9.white,
        bg: variables/* colors.yellow.100 */.O9.yellow[100],
        borderColor: variables/* colors.yellow.100 */.O9.yellow[100],
        shadow: variables/* colors.yellow.100 */.O9.yellow[100]
    },
    success: {
        color: variables/* colors.white */.O9.white,
        bg: variables/* colors.green.100 */.O9.green[100],
        borderColor: variables/* colors.green.100 */.O9.green[100],
        shadow: variables/* colors.green.100 */.O9.green[100]
    },
    primary: {
        color: variables/* colors.white */.O9.white,
        bg: variables/* colors.blue.500 */.O9.blue[500],
        borderColor: variables/* colors.blue.500 */.O9.blue[500],
        shadow: variables/* colors.blue.300 */.O9.blue[300]
    },
    danger: {
        color: variables/* colors.white */.O9.white,
        bg: variables/* colors.red.500 */.O9.red[500],
        borderColor: variables/* colors.red.500 */.O9.red[500],
        shadow: variables/* colors.red.500 */.O9.red[500]
    },
    default: {
        color: variables/* colors.gray.800 */.O9.gray[800],
        bg: variables/* colors.white */.O9.white,
        borderColor: variables/* colors.gray.200 */.O9.gray[200],
        shadow: variables/* colors.gray.50 */.O9.gray[50]
    }
};
const buttonSizes = {
    small: variables/* fontSize.1 */.JB[1],
    normal: variables/* fontSize.3 */.JB[3],
    large: variables/* fontSize.5 */.JB[5]
};
const Button = (props)=>{
    const { children , theme ="default" , type , size , label , icon , iconSize , disabled , iconcolor , loading =false , ...otherProps } = props;
    const currentTheme = buttonThemes[theme];
    const Wrapper = emotion_styled_browser_esm/* default.button */.Z.button(_templateObject(), iconcolor, variables/* fontStyle.family.montserrat */.p_.family.montserrat, (props)=>props.theme.bg, (props)=>props.theme.color, variables/* border.width.2 */.Cg.width[2], (props)=>props.theme.borderColor, icon ? "space-between" : "center", (props)=>props.size, variables/* fontStyle.weight.medium */.p_.weight.medium, variables/* padding.7 */.o3[7], variables/* border.radius.4 */.Cg.radius[4], (disabled || loading) && theme !== "default" && variables/* colors.gray.400 */.O9.gray[400], (disabled || loading) && theme !== "default" && variables/* colors.white */.O9.white, (disabled || loading) && variables/* colors.gray.400 */.O9.gray[400], (props)=>props.theme.shadow);
    const Spinner = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), loading ? "block" : "none", loading && "spin 0.6s infinite linear");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        type: type !== null && type !== void 0 ? type : "button",
        theme: currentTheme,
        size: buttonSizes[size || "normal"],
        disabled: disabled || loading,
        ...otherProps,
        children: [
            loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spinner, {}) : label,
            icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                    name: icon,
                    size: iconSize
                })
            }),
            children
        ]
    });
};
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/components/Button/index.tsx

/* harmony default export */ var components_Button = (Button_Button);


/***/ }),

/***/ 9080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1998);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _variables_border__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9991);
/* harmony import */ var _variables_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4568);
/* harmony import */ var _variables_font_size__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2493);
/* harmony import */ var _variables_font_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(597);
/* harmony import */ var _Form_ValidationError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7982);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6565);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: 100%;\n      "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  cursor: pointer;\n  border: ",
        ";\n  position: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  border-color: ",
        ";\n  background: ",
        ";\n\n  &:focus-within {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: capitalize;\n  line-height: 1;\n  display: block;\n  padding: 2px;\n  margin: 0;\n  border: 0;\n  position: absolute;\n  color: ",
        ";\n  background: ",
        " !important;\n  bottom: 0;\n  transition: all 0.2s ease-in-out;\n  transform-origin: left top;\n  cursor: text;\n  pointer-events: none;\n  font-family: ",
        ";\n  top: ",
        ";\n  width: fit-content !important;\n  height: fit-content;\n  font-size: calc(",
        ");\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  font-size: ",
        ";\n  padding: 0;\n  margin: 0;\n  border: none;\n  outline: none;\n  color: ",
        ";\n  background: transparent;\n  line-height: 1;\n  text-align: left;\n  text-align: -webkit-left;\n\n  &::-webkit-date-and-time-value {\n    text-align: left;\n  }\n\n  &::placeholder {\n    color: ",
        ";\n    opacity: ",
        ';\n    transition: opacity 0.2s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  }\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &[type="number"] {\n    -moz-appearance: textfield; /* Firefox */\n  }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: 1em;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 1em 0;\n  gap: 0.3em;\n  font-size: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}










const inputSizes = {
    small: _variables_font_size__WEBPACK_IMPORTED_MODULE_5__/* ["default"][1] */ .Z[1],
    normal: _variables_font_size__WEBPACK_IMPORTED_MODULE_5__/* ["default"][3] */ .Z[3],
    large: _variables_font_size__WEBPACK_IMPORTED_MODULE_5__/* ["default"][5] */ .Z[5]
};
const FloatingLabelInput = (param)=>{
    let { id , label , value: initialValue , onBlur , onFocus , type , refs , className , size , onChange , withborder =false , disabled , name , error , onKeyUp , min =0 , max , step , ...otherProps } = param;
    const [active, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialValue && initialValue.length > 0);
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialValue);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(refs);
    const handleClick = ()=>{
        ref.current.focus();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setValue(initialValue);
        setActive(!!initialValue);
    }, [
        initialValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (type === "number" && !initialValue) {
            setValue(0);
        }
    }, []);
    const handeleOnFocus = (event)=>{
        setActive(true);
        if (onFocus && !disabled) {
            onFocus(event);
        }
    };
    const handleOnBlur = (event)=>{
        setActive(event.target.value.length !== 0);
        if (onBlur && !disabled) {
            onBlur(event);
        }
    };
    const handleChange = (e)=>{
        onChange && onChange(e);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject()),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(FloatingLabelInputContainer, {
                error: !!error,
                onClick: handleClick,
                className: className,
                withBorder: withborder,
                active: active,
                disabled: disabled,
                size: size,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(FloatingLabel, {
                        htmlFor: id,
                        active: active,
                        size: size,
                        children: label
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(FloatingInput, {
                        onKeyUp: onKeyUp,
                        size: size,
                        active: active,
                        id: id,
                        onBlur: handleOnBlur,
                        onFocus: handeleOnFocus,
                        ref: ref,
                        type: type,
                        onChange: handleChange,
                        value: initialValue,
                        disabled: disabled,
                        name: name,
                        min: min,
                        max: max,
                        step: step,
                        ...otherProps
                    }),
                    type === "number" && step && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(NumberArrows, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("button", {
                                disabled: disabled,
                                type: "button",
                                onClick: ()=>{
                                    max ? onChange && onChange({
                                        target: {
                                            name,
                                            value: value < max ? parseInt(value) + min : max
                                        }
                                    }) : onChange && onChange({
                                        target: {
                                            name,
                                            value: parseInt(value) + min
                                        }
                                    });
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    name: "chevronUp",
                                    size: "tiny"
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("button", {
                                disabled: disabled,
                                type: "button",
                                onClick: ()=>{
                                    min ? onChange && onChange({
                                        target: {
                                            name,
                                            value: value > min ? parseInt(value) - min : min
                                        }
                                    }) : onChange({
                                        target: {
                                            name,
                                            value: parseInt(value) - min
                                        }
                                    });
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    name: "chevronDown",
                                    size: "tiny"
                                })
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_Form_ValidationError__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                message: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FloatingLabelInput);
const FloatingLabelInputContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject1(), (props)=>inputSizes[props.size || "normal"], (props)=>props.withBorder ? "".concat(_variables_border__WEBPACK_IMPORTED_MODULE_3__/* ["default"].width[2] */ .Z.width[2], " solid ").concat(_variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gray[200] */ .Z.gray[200]) : "none", (props)=>props.withBorder && "relative", (props)=>props.withBorder && "1em", _variables_border__WEBPACK_IMPORTED_MODULE_3__/* ["default"].radius[4] */ .Z.radius[4], (props)=>props.error && _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].red[500] */ .Z.red[500], (props)=>props.disabled && _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gray[50] */ .Z.gray[50], _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].blue[500] */ .Z.blue[500]);
const FloatingLabel = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].label */ .Z.label(_templateObject2(), (props)=>props.active ? _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].blue[500] */ .Z.blue[500] : _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gray[150] */ .Z.gray[150], (props)=>props.active ? _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].white */ .Z.white : "transparent", _variables_font_style__WEBPACK_IMPORTED_MODULE_6__/* ["default"].family.montserrat */ .Z.family.montserrat, (props)=>props.active ? "-0.6em" : "1.2em", (props)=>inputSizes[props.size || "normal"]);
const FloatingInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input */ .Z.input(_templateObject3(), (props)=>inputSizes[props.size || "normal"], _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].black */ .Z.black, _variables_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gray[150] */ .Z.gray[150], (props)=>props.active ? 1 : 0);
const NumberArrows = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject4(), _variables_font_size__WEBPACK_IMPORTED_MODULE_5__/* ["default"][1] */ .Z[1]);


/***/ }),

/***/ 7982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ValidationError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(917);
/* harmony import */ var _variables_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4568);
/* harmony import */ var _variables_font_size__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2493);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: ",
        ";\n    padding: 0.2em 0.5em;\n    color: ",
        ";\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




function ValidationError(param) {
    let { message , ...otherProp } = param;
    const style = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _variables_font_size__WEBPACK_IMPORTED_MODULE_2__/* ["default"][1] */ .Z[1], _variables_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].red[500] */ .Z.red[500]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: style,
        ...otherProp,
        children: message
    });
}


/***/ }),

/***/ 2947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PhoneNumberInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(7555);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/style.css
var style = __webpack_require__(6194);
// EXTERNAL MODULE: ./src/components/Form/ValidationError.tsx
var ValidationError = __webpack_require__(7982);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/index.tsx + 2 modules
var variables = __webpack_require__(5334);
;// CONCATENATED MODULE: ./src/components/PhoneNumberInput/PhoneNumberInput.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  border: ",
        " solid ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  border-color: ",
        ";\n\n  .flag-dropdown {\n    border: none;\n    border-right: ",
        " solid ",
        ";\n    border-top-left-radius: ",
        ";\n    border-bottom-left-radius: ",
        ';\n  }\n\n  & ~ *:focus {\n    outline: "none";\n    border-color: ',
        ";\n  }\n\n  &:focus-within {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: auto;\n  padding: ",
        ";\n  padding-left: 0;\n  width: 100%;\n  background: ",
        ";\n\n  font-size: inherit !important;\n\n  .form-control {\n    border: none;\n    width: 100%;\n    height: 100%;\n    background: transparent;\n    font-family: ",
        ";\n    color: ",
        ';\n    font-size: inherit !important;\n\n    &:focus,\n    &:hover {\n      outline: "none";\n    }\n  }\n'
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}







const inputSizes = {
    small: variables/* fontSize.1 */.JB[1],
    normal: variables/* fontSize.3 */.JB[3],
    large: variables/* fontSize.5 */.JB[5]
};
const PhoneNumberInput = (param)=>{
    let { placeholder ="Mobile num" , size ="normal" , value , onChange , error , name , onBlur , disabled =false  } = param;
    const [locData, setLocData] = (0,react.useState)(null);
    const setInitialCountryCode = async ()=>{
        const res = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
        const text = await res.text();
        const [, local] = RegExp("loc=(.*)", "g").exec(text) || [];
        if (!local) return;
        setLocData(local.trim().toLocaleLowerCase());
    };
    (0,react.useEffect)(()=>{
        if (value) return;
        setInitialCountryCode();
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: phoneWrapperStyles({
                    size: inputSizes[size || "normal"],
                    hasErrors: !!error
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((lib_default()), {
                    css: phoneInputStyles({
                        disabled
                    }),
                    onBlur: onBlur,
                    disabled: disabled,
                    country: locData,
                    placeholder: placeholder,
                    value: value,
                    onChange: (value)=>onChange({
                            target: {
                                value: "+".concat(value),
                                name
                            }
                        }),
                    inputProps: {
                        name
                    }
                })
            }),
            error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ValidationError/* default */.Z, {
                message: error
            })
        ]
    });
};
/* harmony default export */ var PhoneNumberInput_PhoneNumberInput = (PhoneNumberInput);
const phoneWrapperStyles = (param)=>{
    let { size , hasErrors  } = param;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), size, variables/* border.width.2 */.Cg.width[2], variables/* colors.gray.300 */.O9.gray[300], variables/* border.radius.3 */.Cg.radius[3], hasErrors && variables/* colors.red.500 */.O9.red[500], variables/* border.width.2 */.Cg.width[2], variables/* colors.gray.300 */.O9.gray[300], variables/* border.radius.3 */.Cg.radius[3], variables/* border.radius.3 */.Cg.radius[3], variables/* colors.blue.500 */.O9.blue[500], variables/* colors.blue.500 */.O9.blue[500]);
};
const phoneInputStyles = (param)=>{
    let { disabled  } = param;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), variables/* padding.7 */.o3[7], disabled && variables/* colors.gray.100 */.O9.gray[100], variables/* fontStyle.family.montserrat */.p_.family.montserrat, variables/* colors.gray.800 */.O9.gray[800]);
};

;// CONCATENATED MODULE: ./src/components/PhoneNumberInput/index.ts

/* harmony default export */ var components_PhoneNumberInput = (PhoneNumberInput_PhoneNumberInput);


/***/ }),

/***/ 655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ passwordRegex; },
/* harmony export */   "Kq": function() { return /* binding */ passwordCriteria; },
/* harmony export */   "c0": function() { return /* binding */ resetPassword; },
/* harmony export */   "ek": function() { return /* binding */ forgotPasswordSchema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4231);

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#]{8,}$/;
const passwordCriteria = (passwordObj)=>{
    const password = passwordObj.value;
    if (!password) return "Password must meet all criteria";
    const criteria = [
        [
            "at least 8 characters",
            password.length >= 8
        ],
        [
            "one lowercase letter",
            /[a-z]/.test(password)
        ],
        [
            "one uppercase letter",
            /[A-Z]/.test(password)
        ],
        [
            "one digit",
            /\d/.test(password)
        ],
        [
            "one symbol",
            /[@$!%*?&#]/.test(password)
        ]
    ];
    const missingCriteria = criteria.filter((param)=>{
        let [_, isValid] = param;
        return !isValid;
    }).map((param)=>{
        let [msg] = param;
        return msg;
    });
    return missingCriteria.length ? "Password must contain ".concat(missingCriteria.join(", ")) : "";
};
const newPasswordObj = {
    new_password: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required("New password is required").matches(passwordRegex, passwordCriteria),
    confirm_password: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().oneOf([
        (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .ref */ .iH)("new_password"),
        null
    ], "Passwords do not match").required("Confirm password is required")
};
const forgotPasswordSchema = (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry)({
    ...newPasswordObj,
    old_password: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required("Old password is required")
});
const createPasswordSchema = (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry)({
    ...newPasswordObj
});
const resetPassword = (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry)({
    email: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().email().required()
});
/* harmony default export */ __webpack_exports__["ZP"] = (createPasswordSchema);


/***/ }),

/***/ 7937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ signup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(1998);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(7041);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(844);
// EXTERNAL MODULE: ./src/components/FloatingLabelInput.tsx
var FloatingLabelInput = __webpack_require__(9080);
// EXTERNAL MODULE: ./src/components/PhoneNumberInput/index.ts + 1 modules
var PhoneNumberInput = __webpack_require__(2947);
// EXTERNAL MODULE: ./src/components/Typography/index.tsx + 1 modules
var Typography = __webpack_require__(1105);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/colors.tsx
var colors = __webpack_require__(4568);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/font-size.tsx
var font_size = __webpack_require__(2493);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/font-style.tsx
var font_style = __webpack_require__(597);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/layout.tsx
var layout = __webpack_require__(5452);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/margins.tsx
var margins = __webpack_require__(8176);
// EXTERNAL MODULE: ./src/assets/styles/utilities/variables/paddings.tsx
var paddings = __webpack_require__(8999);
// EXTERNAL MODULE: ./src/assets/styles/globals.tsx + 1 modules
var globals = __webpack_require__(4987);
// EXTERNAL MODULE: ./src/lib/contexts/ApiContext.ts
var ApiContext = __webpack_require__(8667);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
// EXTERNAL MODULE: ./src/lib/ValidationSchema/createPasswordSchema.ts
var createPasswordSchema = __webpack_require__(655);
;// CONCATENATED MODULE: ./src/lib/ValidationSchema/SignUpSchema.ts


const SignUpSchema = (0,es/* object */.Ry)({
    email: (0,es/* string */.Z_)().email().required(),
    password: (0,es/* string */.Z_)().required().matches(createPasswordSchema/* passwordRegex */.BV, createPasswordSchema/* passwordCriteria */.Kq),
    first_name: (0,es/* string */.Z_)().required(),
    last_name: (0,es/* string */.Z_)().required(),
    clinic_name: (0,es/* string */.Z_)().required(),
    phone: (0,es/* string */.Z_)().required()
});
/* harmony default export */ var ValidationSchema_SignUpSchema = (SignUpSchema);

// EXTERNAL MODULE: ./src/pages/_app.tsx + 8 modules
var _app = __webpack_require__(1311);
;// CONCATENATED MODULE: ./src/pages/signup.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            display: flex;\n            align-items: flex-end;\n            flex-direction: column;\n            gap: 0.8em;\n            & > * {\n              width: 100%;\n            }\n          "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2em;\n  min-height: 100vh;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  padding-bottom: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #cecece;\n  border-radius: 20px;\n  padding: 3em;\n  width: 500px;\n  max-width: 80%;\n  ",
        " {\n    max-width: 100%;\n    padding: 1.5em;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 2em;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  padding-top: ",
        ";\n  a {\n    color: ",
        ";\n    padding: 0 0.5em;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1em;\n  & > * {\n    flex: 1;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  margin: 0 auto ",
        ";\n  ",
        " {\n    width: 35%;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}























const SignUpPage = ()=>{
    const router = (0,next_router.useRouter)();
    const { apiClient , setUser  } = (0,react.useContext)(ApiContext/* default */.Z);
    const [loading, setLoading] = (0,react.useState)(false);
    const getInitialValues = ()=>{
        return {
            email: "",
            password: "",
            first_name: "",
            last_name: "",
            clinic_name: "",
            phone: ""
        };
    };
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: getInitialValues(),
        enableReinitialize: true,
        validationSchema: ValidationSchema_SignUpSchema,
        onSubmit: ()=>{
            handleSubmit();
        }
    });
    async function handleSubmit() {
        setLoading(true);
        const requestData = formik.values;
        try {
            const res = await apiClient.registration(requestData);
            (0,lib.setCookie)("".concat("ddtw"), res.accessToken, {
                maxAge: 3600 * 24 * 7 * 8
            });
            setUser(res);
            localStorage.removeItem("cal-vw");
            localStorage.removeItem("cal-month");
            localStorage.removeItem("cal-week");
            localStorage.removeItem("cal-day");
            router.push({
                pathname: "/",
                query: router.query
            });
        } catch (err) {
            _app.appToast.error(err.message);
        } finally{
            setLoading(false);
        }
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: "SignUp"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(globals/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    src: "/LOGO WITHOUT TYPE.png",
                    alt: "dendots",
                    width: "144",
                    height: "144",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignUpForm, {
                onSubmit: formik.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginTitle, {
                        as: "h1",
                        content: "SIGN UP"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject()),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingLabelInput/* default */.Z, {
                                withborder: true,
                                onChange: formik.handleChange,
                                label: "Clinic Name",
                                name: "clinic_name",
                                onBlur: formik.handleBlur,
                                error: formik.touched.clinic_name ? formik.errors.clinic_name : ""
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingLabelInput/* default */.Z, {
                                        withborder: true,
                                        onChange: formik.handleChange,
                                        label: "First name",
                                        name: "first_name",
                                        onBlur: formik.handleBlur,
                                        error: formik.touched.first_name ? formik.errors.first_name : ""
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingLabelInput/* default */.Z, {
                                        withborder: true,
                                        onChange: formik.handleChange,
                                        label: "Last name",
                                        name: "last_name",
                                        onBlur: formik.handleBlur,
                                        error: formik.touched.last_name ? formik.errors.last_name : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingLabelInput/* default */.Z, {
                                withborder: true,
                                onChange: formik.handleChange,
                                label: "Email",
                                name: "email",
                                onBlur: formik.handleBlur,
                                error: formik.touched.email ? formik.errors.email : ""
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneNumberInput/* default */.Z, {
                                onChange: formik.handleChange,
                                onBlur: formik.handleBlur,
                                error: formik.touched.phone ? formik.errors.phone : "",
                                name: "phone"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingLabelInput/* default */.Z, {
                                withborder: true,
                                type: "password",
                                onChange: formik.handleChange,
                                label: "Password",
                                name: "password",
                                onBlur: formik.handleBlur,
                                error: formik.touched.password ? formik.errors.password : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                        label: "Create an account",
                        theme: "primary",
                        css: signUpButtonCss,
                        type: "submit",
                        disabled: loading
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoginText, {
                        children: [
                            "Already have an account?",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                onClick: ()=>router.push({
                                        pathname: "/login",
                                        query: router.query
                                    }),
                                children: "Log in"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var signup = (SignUpPage);
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
const LoginTitle = (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(_templateObject2(), font_style/* default.family.montserrat */.Z.family.montserrat, font_size/* default.7 */.Z[7], font_style/* default.weight.bold */.Z.weight.bold, paddings/* default.6 */.Z[6], colors/* default.gray.800 */.Z.gray[800]);
const SignUpForm = emotion_styled_browser_esm/* default.form */.Z.form(_templateObject3(), layout/* default.mediaBreakpointDown */.Z.mediaBreakpointDown("lg"));
const signUpButtonCss = (0,emotion_react_browser_esm/* css */.iv)(_templateObject4());
const LoginText = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5(), font_style/* default.family.montserrat */.Z.family.montserrat, font_size/* default.1 */.Z[1], colors/* default.gray.400 */.Z.gray[400], paddings/* default.9 */.Z[9], colors/* default.blue.500 */.Z.blue[500]);
const Row = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
const Logo = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7(), margins/* default.10 */.Z[10], layout/* default.mediaBreakpointDown */.Z.mediaBreakpointDown("lg"));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7694,4231,2175,4425,9774,2888,179], function() { return __webpack_exec__(7805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);